import { Box } from '@mui/material';
import type { FC, ReactNode } from 'react';

interface PropertyListProps {
  children: ReactNode;
}

export const PropertyList: FC<PropertyListProps> = props => {
  const { children } = props;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        columnGap: 2,
      }}>
      {children}
    </Box>
  );
};
